module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/047-dominican-republic-0e6e3f76dd558dd0dd5ba153b59c09ec.svg";